const getStorage = key => {
    return localStorage.getItem(key) || undefined;
};

const setStorage = (key, item) => {
    localStorage.setItem(key, item);
};

const removeStorage = key => {
    localStorage.removeItem(key);
};

const removeAllStorage = () => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted') || undefined;
    localStorage.clear();
    cookiesAccepted && localStorage.setItem('cookiesAccepted', cookiesAccepted);
};
export { getStorage, setStorage, removeStorage, removeAllStorage };
